(function ($) {
    $(document).ready(function () {

        let section = $(".fullscreen-search-modal");
        let searchIcon = $(".search-icon");

        //open modal
        searchIcon.on("click", () => {
            section.fadeIn(200).css({"display": "flex"});
            section.find("input").trigger("focus");
        })

        //close modal
        section.on("click", [".close-modal", ".fullscreen-search-modal"], () => {
            section.fadeOut(200);
        })

        //stop propagation
        section.on("click", ".search-form-wrap", (e) => {
            e.stopPropagation();
        })

    })
})(jQuery);